import { render, staticRenderFns } from "./PdpBuyingZoneContainer.vue?vue&type=template&id=a0f18f5a&"
import script from "./PdpBuyingZoneContainer.vue?vue&type=script&lang=js&"
export * from "./PdpBuyingZoneContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports